exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr.highlight[data-v-0e7206bb]{background-color:#fae19e;transition:background-color .25s ease-in-out}tr.highlight[data-v-0e7206bb]:hover{background-color:#f7c94a}", ""]);

// exports
